import { render, staticRenderFns } from "./AssignVendorModal.vue?vue&type=template&id=b6621f92&scoped=true&"
import script from "./AssignVendorModal.vue?vue&type=script&lang=js&"
export * from "./AssignVendorModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignVendorModal.vue?vue&type=style&index=0&id=b6621f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6621f92",
  null
  
)

export default component.exports